module.exports = __webpack_public_path__ + "img/视频场景_视频编辑.819a1a7b.png";